<template>
  <v-app id="ui" fluid tag="section" >
    <v-card class="ma-5"> 

      
      
      <div v-if="session.account[0].username=='kensrin' || session.account[0].username=='kensrin@kensrin.com' || session.account[0].username=='rura@rura.com'">
        <Notification></Notification>
      <v-card-title>
        <v-row style="margin-top: -9px">
          <v-col>  
                <v-btn tile small class="mt-4" @click="add_dialog=true" color="blue"> Add Asset</v-btn> 
                <v-btn tile small class="mt-4" @click="selected.length>0? renewal_dialog=true: setNotification('error','Select asset to renew')" color="green">Renew Certificate</v-btn> 
          </v-col>
          <v-col cols="5">
            <v-row style="margin-top: -9px">
              <v-col>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-btn tile small class="mt-4" :loading="isexporting" :disabled="isexporting">
                  <download-excel
                    :data="sys_data"
                    :fields="export_header" 
                    name="sg_report.xls"
                  >
                    <v-icon>mdi-file-excel-outline</v-icon>Export
                  </download-excel>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <br />
 
      <div class=" ml-3 mr-3">
          <v-data-table
                  class="elevation-1"
                  :headers="headers"
                  :items="sys_data"
                  :search="search"
                  :single-select="singleSelect"
                  v-model="selected"
                  :loading="loading"
                  show-select
                  fixed-header
                  :height="sys_data.length>10?'500px':''"
                  loading-text="Loading... Please wait"
                  item-key="recid" 
                  :custom-filter="customFilter"
                > 
                  <template v-slot:item.certexpiry="{ item }">
                    <v-chip
                      :color="checkexpiry(item.certexpiry).color"
                      dark
                    >{{ checkexpiry(item.certexpiry).text }}</v-chip>
                  </template>
           
                </v-data-table>
      </div> 
      </div> 

      <center class="mt-4"  v-else>
        <h3>Premium Feature</h3>
        <br>
        <v-icon  x-large color="deep-purple">mdi-tools</v-icon>
        <br><br>
        Sorry this is a premium feature. <br> <br>
        <!-- Contact Kensrin Customer Support for activation.
        <br> <br> -->
      </center>

       <v-dialog v-model="renewal_dialog" style="background:#fff" persistent max-width="580px">
        <v-card flat>
          <v-card-text>Enter renewal period</v-card-text>
          
            <v-select
            class="ma-4"
            v-model="renew_period"
            hint="Years"
            :items="[1,2,3,4]" 
            label="Select Renewal Period"
            persistent-hint
            return-object
            single-line
          ></v-select>

          <v-card-actions>
            <v-btn tile small class="mt-4" @click="renew" :loading="loading" color="green">Renew Certificate</v-btn> 
            <v-btn text small class="mt-5" @click="renewal_dialog=false" > Close</v-btn> 
          </v-card-actions>
        </v-card>
      </v-dialog>  

      <v-dialog v-model="add_dialog" style="background:#fff" persistent width="800px">
        <v-card flat>
          <v-card-title>Add New Asset</v-card-title>
           <Notification></Notification>
          <v-card-text>
            <v-sheet>
              <v-form ref="forms">
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="registration"
                      label="Vehicle Registraion"
                      class="purple-input"
                      :rules="requiredRules"
                      hide-details="auto"
                    />
                    <br />
                     <v-text-field
                      v-model="chassis"
                      label="Chassis Number"
                      class="purple-input"
                      hide-details="auto"
                    />
                    <br />
                    
                    <v-text-field
                      label="Make"
                      :rules="requiredRules"
                      v-model="make"
                      class="purple-input"
                      hide-details="auto"
                    />
                    <br />
                    <v-text-field
                      v-model="serialno"
                      label="Device Serial"
                      class="purple-input"
                      :rules="requiredRules"
                      hide-details="auto"
                    /> 
                    <br>
                    <v-text-field
                      v-model="certno"
                      label="Certificate No."
                      class="purple-input"
                      :rules="requiredRules"
                      hide-details="auto"
                    /> 
                    <br>
                    <v-select
                      :items="[1,2,3]"
                      :rules="requiredRules"
                      v-model="period"
                      hint="Years"
                      label="Period"
                    ></v-select>
                  </v-col>

                  <v-col>
                    <v-datetime-picker  label="Installation Date" v-model="installationdate"> </v-datetime-picker> 
                    <v-text-field
                      v-model="imei"
                      label="Imei Number"
                      :rules="requiredRules"
                      class="purple-input" 
                      hide-details="auto"
                    /> 
                    <br />
                    <v-text-field
                      v-model="limitertype"
                      label="Limiter Type" 
                      :rules="requiredRules"
                      class="purple-input"
                      hide-details="auto"
                    />
                    <br />  
                    <v-row>
                      <v-col cols="8">
                        <v-autocomplete
                                :items="custs.cust"
                                v-model="ownerid"
                                label="Owner" 
                                item-value="idno"
                                item-text="owner_name"
                                @change="selectcust"
                                class="purple-input"
                                :rules="requiredRules"
                                hide-details="auto"
                        > 
                        <template slot="item" slot-scope="data" > 
                          <span> {{"Name : "+ data.item.owner_name +" ,ID : "+  data.item.idno +" , Phone : "+ data.item.owner_phone }}</span> 
                        </template>
                        </v-autocomplete>

                      </v-col>
                      <v-col cols="3">
                          <v-btn tile small class="mt-5" @click="customer_dialog=true" color="navy">Add New</v-btn> 
                      </v-col>
                    </v-row>  

                    <v-row>
                      <v-col cols="8">
                        <v-autocomplete
                                :items="custs.agent"
                                v-model="agentname"
                                label="Fitting Center"
                                class="purple-input" 
                                item-value="agent"
                                item-text="agent"
                                @change="selectagent"
                                :rules="requiredRules"
                                hide-details="auto">  
                        </v-autocomplete>
                         
                      </v-col>
                      <v-col cols="3">
                          <v-btn tile small class="mt-5" @click="agent_dialog=true" color="navy">Add New</v-btn>
                      </v-col>
                    </v-row> 
                  </v-col> 
                </v-row>
                
                 <v-card-actions>
                  <v-btn color="red darken-1" text @click="add_dialog = false">Close</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    :loading="loading"
                    :disabled="loading"
                    text
                    @click="add"
                  >Save</v-btn>
                </v-card-actions>
                
              </v-form>
            </v-sheet>
          </v-card-text>  
        </v-card>
      </v-dialog> 

    <v-dialog v-model="customer_dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Client</span>
        </v-card-title>
         <Notification></Notification>
        <v-card-text>
          <v-container>
            <v-form ref="custs"> 
              <v-text-field
                          v-model="ownerid"
                          label="Owner ID number"
                          type="number"
                          :rules="numRules"
                          step="any"
                          class="purple-input"
                          hide-details="auto"
                        />
              <br>
               <v-text-field
                v-model="ownername"
                label="Owner Name"
                type="text"
                :rules="requiredRules"
                class="purple-input"
                hide-details="auto"
              ></v-text-field>
              <br>
               <v-text-field
                v-model="ownerphone"
                label="Owner Phone"
                type="text"
                :rules="requiredRules"
                class="purple-input"
                hide-details="auto"
              ></v-text-field>
              <br>
               <v-text-field
                v-model="owneremail"
                label="Owner Email"
                type="email" 
                class="purple-input"
                hide-details="auto"
              ></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="customer_dialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            :disabled="loading"
            text
            @click="addcust"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="agent_dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Fitting Center</span>
        </v-card-title>
         <Notification></Notification>
        <v-card-text>
          <v-container>
            <v-form ref="agent"> 
              <v-text-field
                          v-model="agentname"
                          label="Fitting Center" 
                          :rules="requiredRules" 
                          class="purple-input"
                          hide-details="auto"
                        />
              <br>
               <v-text-field
                v-model="agentloc"
                label="Fitting center location"
                type="text"
                :rules="requiredRules"
                class="purple-input"
                hide-details="auto"
              ></v-text-field>
              <br>
               <v-text-field
                v-model="agentphone"
                label="Fitting Center Phone"
                type="text"
                :rules="requiredRules"
                class="purple-input"
                hide-details="auto"
              ></v-text-field>
              <br>
               <v-text-field
                v-model="agentemail"
                label="Fitting Center Email"
                type="email" 
                class="purple-input"
                hide-details="auto"
              ></v-text-field>
              <br>
               <v-text-field
                v-model="agentbsn"
                label="Fitting Center Business Registration"
                type="text"
                :rules="requiredRules"
                class="purple-input"
                hide-details="auto"
              ></v-text-field>

            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="agent_dialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            :disabled="loading"
            text
            @click="addagent"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-card>
  </v-app>
</template>

<style>
#ui {
  background: #eee;
  background: #ddd
} 
</style>

<script>
import { mapState } from "vuex";
import moment, { months } from "moment";
import common from "../mixins/common";
import DatetimePicker from 'vuetify-datetime-picker'  
import vue from "vue";
vue.use(DatetimePicker)

export default {
  name: "masterdata",
  components: { 
    downloadExcel: () => import("vue-json-excel"),
    Notification: () => import("../components/Notification")
  }, 
  data() {
    return { 
      renewal_dialog: false, 
      add_dialog: false,
      agent_dialog: false, 
      customer_dialog: false,
      loading: false,
      singleSelect: true,
      selected: [],
      m_notification: [],

      renew_period: '',
      search: "",
       
      installationdate: "",
      period: "", 
      registration: "",
      chassis: "",
      make: "",
      serialno: "",
      certno: "",
      limitertype: "",
      ownerid: "",
      ownername: "",
      ownerphone: "",
      owneremail: "",
      agentname: "",
      agentloc: "",
      agentemail: "",
      agentphone: "",
      agentbsn: "",
      imei: "",

      popup: "",

      headers: [
        { text: "Registration", value: "regno"},
        { text: "Make", value: "make" },  
        { text: "Chassis", value: "chassis" },
        { text: "Owner", value: "owner" },
        { text: "Owner Phone", value: "phone" },
        { text: "Fitting Center", value: "fittingcenter" }, 
        { text: "Fitting Location", value: "location" }, 
        { text: "Fitting Date", value: "installdate" },
        { text: "Certificate Expiry", value: "certexpiry" }, 
        { text: "Limiter Type", value: "limitertype" },
        { text: "Serial no.", value: "serialno" },
        { text: "Imei", value: "imei" } 
      ],   
      export_header: {
        "Registration":"regno",
        "Make":"make",  
        "Chassis":"chassis",
        "Owner":"owner",
        "Phone":"phone",
        "Fitting Center":"fittingcenter", 
        "Fitting Location":"location",
        "Serial No.":"serialno",
        "Imei":"imei",
        "Limiter type":"limitertype",
        "Installation Date":"installdate",
        "Certificate Expiry":"certexpiry"
      },
      isexporting: false,
      sys_data: [],
      unfiltered_data: [], 
      custs: []
    };
  },
  mixins: [common],
  created() {
    this.customers();
    this.available_data();
  },
  computed: {
    ...mapState(["session"])
  },

  methods: {
 
    setNotification(t, m) {
      this.m_notification["msg"] = m;
      this.m_notification["type"] = t;
      this.$store.commit("SET_NOTIFICATION", this.m_notification);
    }, 

    checkexpiry(aspdate) {
      if(aspdate){
        if(moment().isAfter(moment(aspdate))){
          return {color: "red", text: moment(aspdate).format("DD/MM/YYYY") + " (Expired!)"};
        }

         if(Math.abs(moment().diff(moment(aspdate),'days')) <= 90)
          return {color: "accent", text: moment(aspdate).format("DD/MM/YYYY") + " (Expires soon)"};
        else
          return {color: "success", text: moment(aspdate).format("DD/MM/YYYY")};
      } 
      return {color: "red", text: "Expiry Missing!"};
    },

    customFilter(value, search, item) {
      var s = search.split(" ");
      if (value != null && search != null) {
        var found = false;
        for (var m = 0; m < s.length; m++) {
          if (s[m] !== "") {
            if (
              Object.entries(item).some(f =>
                f[1]
                  .toString()
                  .toLowerCase()
                  .includes(s[m].toLowerCase())
              )
            )
              found = true;
            else found = false;
          }
        }
        return found;
      }
    },
 
    available_data() {
      this.loading = true;
      this.http_connect_node("/sg",{ token: this.check_token(), country: process.env.VUE_APP_COUNTRY })
        .then(res => {  
          if (res.status == 200) { 
            this.sys_data = res.data.payload.sg; 
            this.unfiltered_data =  res.data.payload.sg; 
          } else {
            this.setNotification(
              "error",
              "Failed to fetch records please try again."
            );
            this.loading = false;
          }
          this.loading = false;
        })
        .catch(err => {
          this.setNotification("error", "Failed to fetch records.");
          this.loading = false;
        });
    },

    customers() {
      this.loading = true;
      this.http_connect_node("/sg_custs",{ token: this.check_token(), country: process.env.VUE_APP_COUNTRY })
        .then(res => {  
          if (res.status == 200) {  
            this.custs = res.data.payload;   
          }
        })
        .catch(err => {
          this.setNotification("error", "Failed to fetch records.");
          this.loading = false;
        });
    },


    renew() {
       if(this.renew_period){
        this.loading = true;
        this.http_connect_node("/sg_renew",{ token: this.check_token(), id: this.selected[0].recid, year: this.renew_period })
          .then(res => {  
            if (res.status == 200) { 
              this.setNotification("success", res.data.payload); 
              this.available_data();
            } else 
              this.setNotification("error", res.data.payload);  
            this.renewal_dialog = false;
          })
          .catch(err => {
            this.setNotification("error", "Failed to fetch records.");
            this.renewal_dialog = false;
          }); 
      }else 
        alert('Select renewal period') 
    },
 
    add(){
       if (this.$refs.forms.validate()) {
        this.loading = true;
        this.http_connect_node("/sg_add",{ 
            token: this.check_token(), 
            country: process.env.VUE_APP_COUNTRY,
            agent_loc: this.agentloc,
            agent: this.agentname,
            regno: this.registration,
            agent_phone: this.agentphone,
            agent_email: this.agentemail,
            bsnno: this.agentbsn,
            owner_name: this.ownername,
            idno: this.ownerid,
            owner_email:  this.owneremail,
            owner_phone: this.ownerphone,
            installationdate: this.installationdate,
            period: this.period,
            chassis: this.chassis,
            make: this.make,
            serialno: this.serialno,
            limiterserial: this.certno,
            imei: this.imei,
            limitertype: this.limitertype
        }) 
          .then(res => {   
            if (res.status == 200) {  
              this.setNotification("success", res.data.payload); 
              try {
                 this.$refs.custs.reset(); 
              } catch (error) { }

              try { 
                this.$refs.agent.reset();
              } catch (error) { }
             
              this.$refs.forms.reset();
              this.available_data();
            } else 
              this.setNotification("error", res.data.payload);  
            this.add_dialog = false;
            this.loading = false;
          })
          .catch(err => { 
            this.setNotification("error", "Failed to add records.");
            this.add_dialog = false;
            this.loading = false;
          }); 
      }else 
        alert('Ensure all fields are required.') 
    },
    selectcust(){
      if(this.ownerid){ 
         this.custs.cust.filter(h=> h.idno==this.ownerid).map(e=> {
              this.ownername = e.owner_name;
              this.ownerphone = e.owner_phone;
              this.owneremail = e.owner_email;
              this.idno = e.idno; 
            });
      }
    },

    addcust(){  
        if (this.$refs.custs.validate()) {
          if(this.custs.cust.filter(h=> h.idno==this.ownerid).length>0){
            this.setNotification("error", "Customer already exists with that id number. New details will not be added.");
            custs.cust.filter(h=> h.idno==this.ownerid).map(e=> {
              this.ownername = e.owner_name;
              this.ownerphone = e.owner_phone;
              this.owneremail = e.owner_email;
              this.idno = e.idno;
               this.ownerid = e.idno;
            }); 
          }  else 
            this.custs.cust.push({owner_name: this.ownername, owner_phone: this.ownerphone, idno: this.ownerid})
          
          this.customer_dialog = false
        } else
          alert('Enter the required details.')
    },
    selectagent(){
      if (this.agentname) {
        this.custs.agent.filter(h=> h.agent==this.agentname).map(e=> { 
              this.agentloc = e.namenloc;
              this.agentphone = e.agentphone;
              this.agentemail = e.email;
              this.agentbsn = e.regno; 
            });
      }
    },
    addagent(){  
        if (this.$refs.agent.validate()) {
          if(this.custs.agent.filter(h=> h.agent==this.agentname).length>0){
            this.setNotification("error", "Fitting center already exists with that name. New details will not be added.");
            this.custs.agent.filter(h=> h.agent==this.agentname).map(e=> {
              this.agentloc = e.namenloc;
              this.agentphone = e.agentphone;
              this.agentemail = e.email;
              this.agentbsn = e.regno; 
            });  
          }  else  
             this.custs.agent.push({agent: this.agentname, namenloc: this.agentloc, agentphone: this.agentphone, regno: this.agentbsn})
          this.agent_dialog = false
        } else
          alert('Enter the required details.')
    }

  }
  
};
</script>

